module.exports = __webpack_public_path__ + "static/img/award4.7a2b779.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/e-pc/award4.jpg
// module id = 9
// module chunks = 0